/* @flow strict
 *
 * Builder for Protobuf Schema oneOfs generated by protobuf-gen-flow
 * generated from tinder/events/model/app/app.proto
 */

import type { AppAttributes as Tinder_Events_Model_Common_Session_AppAttributes } from 'Lib/eventsSDK/events/tinder/events/model/common/session/app';
import type { AppPlatformEvent } from 'Lib/eventsSDK/events/tinder/events/model/app/platform';
import type { AuthAttributes as Tinder_Events_Model_Common_Session_AuthAttributes } from 'Lib/eventsSDK/events/tinder/events/model/common/session/auth';
import type { DeviceAttributes as Tinder_Events_Model_Common_Session_DeviceAttributes } from 'Lib/eventsSDK/events/tinder/events/model/common/session/device';
import type { LocationAttributes as Tinder_Events_Model_Common_Session_LocationAttributes } from 'Lib/eventsSDK/events/tinder/events/model/common/session/location';
import type { StringValue as Google_Protobuf_StringValue } from 'Lib/eventsSDK/events/google/protobuf/wrappers';
import type { Timestamp as Google_Protobuf_Timestamp } from 'Lib/eventsSDK/events/google/protobuf/timestamp';
import type { UserAttributes as Tinder_Events_Model_Common_Session_UserAttributes } from 'Lib/eventsSDK/events/tinder/events/model/common/session/user';
import type { AppEvent } from 'Lib/eventsSDK/events/tinder/events/model/app/app';
import type { AppEventBatch } from 'Lib/eventsSDK/events/tinder/events/model/app/app';
import type { AppEventSession } from 'Lib/eventsSDK/events/tinder/events/model/app/app';
export const APP_EVENT_PLATFORM: 'platform' = 'platform'; // AppPlatformEvent

export type OneOfAppEventValue = {| schema: typeof APP_EVENT_PLATFORM, ...AppPlatformEvent |};

/**
 * Builds Protobuf Message tinder.events.model.app.AppEvent.
 * Generated by Protobuf-gen-flow.
 * @param {Object} data
 * @return {AppEvent}
 */

export function appEventBuilder({
  id,
  createTime,
  eventSession,
  oneOfvalue = {}
}: {
  id?: Google_Protobuf_StringValue,
  createTime?: Google_Protobuf_Timestamp,
  eventSession?: AppEventSession,
  oneOfvalue?: OneOfAppEventValue
}): AppEvent {
  const result: AppEvent = {
    id,
    createTime,
    eventSession
  };

  const { schema: value, ...valueData } = oneOfvalue;
  if (value !== undefined) {
    // $FlowFixMe - some versions of flow do not compute oneOf fields properly
    result[value] = valueData;
  }

  return result;
}

